import { CheckboxGroup, DateInput, Field, RadioGroup } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { CompactiveEffort } from 'Components/Worksheets/ConvertedWetDensityWorksheet/types';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { hasValue } from 'Lib/Any';
import { DateTimeDataFormat } from 'Lib/Format';
import moment from 'moment';
import React, { useState } from 'react';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import AsFindTestsButton from './FindTestsButton';

let AsTestQuerySection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const defaultEndDate = moment();
  const defaultStartDate = moment.min([moment(), moment(defaultEndDate).subtract(30, 'd')]);
  const [startDateSelected, setStartDate] = useState<string>(defaultStartDate.format('YYYY-MM-DD'));
  const [endDateSelected, setEndDate] = useState<string>(defaultEndDate.format('YYYY-MM-DD'));
  return (
    <>
      <ListFieldSection heading="Find Tests">
        <Field
          input={<DateInput />}
          label="Date Sampled From"
          dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
          value={startDateSelected}
          onChange={(e: any) => setStartDate(e.data.value)}
          messages={
            !hasValue(startDateSelected)
              ? [{ severity: 'error', message: 'Date Sampled From is required to search for tests.' }]
              : []
          }
        />
        <Field
          input={<DateInput />}
          label="Date Sampled To"
          dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
          value={endDateSelected}
          onChange={(e: any) => setEndDate(e.data.value)}
          messages={
            !hasValue(endDateSelected)
              ? [{ severity: 'error', message: 'Date Sampled To is required to search for tests.' }]
              : []
          }
        />
        <Field
          label="Filters"
          input={<CheckboxGroup />}
          options={[
            {
              name: 'ValueAssignment.RestrictByCompletedTests',
            },
            {
              name: 'ValueAssignment.RestrictByProject',
            },
            {
              name: 'ValueAssignment.RestrictBySource',
            },
            {
              name: 'ValueAssignment.RestrictByMaterial',
            },
          ]}
        />

        <Field
          input={<RadioGroup />}
          name="ValueAssignment.CompactionMethod"
          options={[
            { label: 'Standard (AS 1289.5.1.1)', value: CompactiveEffort.Standard },
            { label: 'Modified (AS 1289.5.2.1)', value: CompactiveEffort.Modified },
          ]}
        />

        <AsFindTestsButton startDate={startDateSelected} endDate={endDateSelected} />
      </ListFieldSection>
    </>
  );
};

AsTestQuerySection = withInjectedProps(AsTestQuerySection);

export { AsTestQuerySection };
export default AsTestQuerySection;
